import { LinkText } from '@components/LinkText';
import { Pagination } from '@components/Table/Pagination';
import { TableHeaderCellAction } from '@components/Table/TableHeaderCellAction';
import { TableLinearLoading } from '@components/Table/TableLinearLoading';
import { TableNoResult } from '@components/Table/TableNoResult';
import { TableSortCell } from '@components/Table/TableSortCell';
import { TableSortRow } from '@components/Table/TableSortRow';
import { TableWrapper } from '@components/Table/TableWrapper';
import { IData } from '@hooks/useData';
import { IModalWindow } from '@hooks/useModalWindow';
import { IconButton, TableBody, TableCell, TableHead, TableRow, Tooltip } from '@material-ui/core';
import HistoryIcon from '@material-ui/icons/History';
import { ICliente } from '@model/Cliente';
import { IClienteFilter } from '@services/ClienteService';
import { useThemeColor } from '@themes/Colors';
import clsx from 'clsx';
import React from 'react';

export type ClienteTableProps = {
    data: IData<ICliente, IClienteFilter>
    isLoading: boolean
    atividadeModal: IModalWindow
}

export function ClienteTable ({ data, isLoading, atividadeModal }: ClienteTableProps) {
    const themeColor = useThemeColor();

    return (
        <TableWrapper>
            <TableLinearLoading isLoading={isLoading} />
            <TableNoResult itemCount={data.itemsCount}>
                <TableHead>
                    <Pagination pagination={data.pagination} />

                    <TableSortRow sort={data.sort}>
                        <TableSortCell fieldName="clienteId">ID</TableSortCell>
                        <TableSortCell fieldName="nome">Nome</TableSortCell>
                        <TableSortCell fieldName="cpf">Documento</TableSortCell>
                        <TableHeaderCellAction />
                    </TableSortRow>
                </TableHead>
                
                <TableBody>
                    {
                        data.items.map((cliente, index) => {
                            return (
                                <TableRow key={index}>
                                    <TableCell><strong>{cliente.clienteId}</strong></TableCell>
                                    <TableCell><LinkText text={cliente.nome} to={`/cliente/${cliente.clienteId}`} className={clsx({
                                        [themeColor.status.vermelhoClaro]: cliente.temFaturaVencida
                                    })} /></TableCell>
                                    <TableCell>{cliente.cpf}</TableCell>
                                    <TableCell>
                                        <Tooltip title="Atividades">
                                            <IconButton onClick={data.handleRowFocused(cliente, atividadeModal.open)}>
                                                <HistoryIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </TableCell>
                                </TableRow>
                            )
                        })
                    }

                    <Pagination pagination={data.pagination} />

                </TableBody>
            </TableNoResult>
        </TableWrapper>
    )
}